/**
 * @description Ad setup type
 */
export enum AdSetupType {

	/**
	 * @description Client Side Ad Insertion
	 */
	CSAI = 'csai',

	/**
	 * @description Server Side Ad Insertion
	 */
	SSAI = 'ssai',

}